// extracted by mini-css-extract-plugin
export default {"wrap":"GH-z","articleImagesWrap":"HH-z","articleImage":"IH-z","singleImage":"JH-z"};